import NavigationBar from '@/components/home/_components/navigation-bar';
import TombolaContextMenuComponent from '@/components/home/_components/tombola-context-menu';
import SearchBarComponent from '@/components/home/_components/search-bar';
import TombolaModalLayoutComponent from '@/components/home/_components/tombola-modal-layout';
import TombolaShortcutOverlayComponent from '@/components/home/_components/tombola-shortcut-overlay';

const homeChildComponents = {
  appNavigationbar: NavigationBar,
  tombolaContextMenu: TombolaContextMenuComponent,
  searchBar: SearchBarComponent,
  tombolaModalLayout: TombolaModalLayoutComponent,
  tombolaShortcutOverlay: TombolaShortcutOverlayComponent
};
export default homeChildComponents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/index.ts